import classnames from 'classnames/bind'
import styles from './Layout.module.scss'
const cx = classnames.bind(styles)

import type { FC, ReactNode } from 'react'

interface Props {
  children: ReactNode
}

const Layout: FC<Props> = ({ children }) => {
  return (
    <div id="wrapper">
      <header id="header" className={cx('header')}>
        <img src="/img/logo.svg" alt="TotalSystemCare" width="180" />
      </header>
      <div className={cx('main')}>{children}</div>
      <footer className={cx('footer-minimal', 'ftr-sticky')}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="ftr-copy text-center">
                &copy; {new Date().getFullYear()} All Rights Reserved. SB
                Software Group LLC.
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Layout
